import {
  LayoutDashboard, Brain, BarChart3, ScrollText, Users, UserPlus, KeyRound,
  MonitorSmartphone, IdCard, Gauge, Compass, Heart, Sparkles, Search, Send, Star,
  FolderHeart, HeartHandshake, ClipboardList, MessageCircleHeart, NotebookPen,
  MessageSquare, Contact, Image, Phone, Bell, Mail, MailCheck, Radio, CalendarClock,
  Users2, ShieldCheck, GalleryVerticalEnd, Flag, BookOpen, CreditCard, Crown, Rocket,
  Ticket, Gift, CalendarDays, LifeBuoy, SlidersHorizontal, Power, ToggleLeft, Server,
  Timer, Activity, Lock, UserCog, UserCheck, AlertTriangle, IndianRupee, Circle,
} from "lucide-react";

export const ICONS = {
  LayoutDashboard, Brain, BarChart3, ScrollText, Users, UserPlus, KeyRound,
  MonitorSmartphone, IdCard, Gauge, Compass, Heart, Sparkles, Search, Send, Star,
  FolderHeart, HeartHandshake, ClipboardList, MessageCircleHeart, NotebookPen,
  MessageSquare, Contact, Image, Phone, Bell, Mail, MailCheck, Radio, CalendarClock,
  Users2, ShieldCheck, GalleryVerticalEnd, Flag, BookOpen, CreditCard, Crown, Rocket,
  Ticket, Gift, CalendarDays, LifeBuoy, SlidersHorizontal, Power, ToggleLeft, Server,
  Timer, Activity, Lock, UserCog, UserCheck, AlertTriangle, IndianRupee,
};

export const Icon = ({ name, className }) => {
  const C = ICONS[name] || Circle;
  return <C className={className} />;
};
